import LayoutAdmin from "@/layouts/layoutAdmin.vue";
import style from "@/views/module/production/masterSetup/style.vue";
import pos from "@/views/module/production/masterSetup/pos.vue";
import color from "@/views/module/production/masterSetup/color.vue";
import size from "@/views/module/production/masterSetup/size.vue";
import bom from "@/views/module/production/bom/bom.vue";
import bomRecord from "@/views/module/production/bom/bomRecord.vue";
import cuttingCreate from "@/views/module/production/cutting/cuttingCreate.vue";
import cuttingRecords from "@/views/module/production/cutting/cuttingRecords.vue";
import viewCutting from "@/views/module/production/cutting/viewCutting.vue";
import bundleCreate from "@/views/module/production/bundle/bundleCreate.vue";
import bundleRecords from "@/views/module/production/bundle/bundleRecords.vue";
import sewingLine from "@/views/module/production/sewing/sewingLine.vue";
import sewingInput from "@/views/module/production/sewing/sewingInput.vue";
import sewingOutput from "@/views/module/production/sewing/sewingOutput.vue";

import sewingInputRecord from "@/views/module/production/sewing/sewingInputRecords.vue";
import sewingOutputRecord from "@/views/module/production/sewing/sewingOutputRecords.vue";
import sewingInputView from "@/views/module/production/sewing/sewingInputView.vue";
import sewingOutputView from "@/views/module/production/sewing/sewingOutputView.vue";

import qcEntry from "@/views/module/production/qc/qcEntry.vue";
import qcRecords from "@/views/module/production/qc/qcRecords.vue";
import qcView from "@/views/module/production/qc/qcView.vue";


import finishingEntry from "@/views/module/production/finishing/finishingEntry.vue";
import finishingRecords from "@/views/module/production/finishing/finishingRecords.vue";
import finishingView from  "@/views/module/production/finishing/finishingView.vue";

import styleReport from "@/views/module/production/reports/styleReport.vue";
import poReport from "@/views/module/production/reports/poReport.vue";
import cuttingReport from "@/views/module/production/reports/cuttingReport.vue";
import bundleReport from "@/views/module/production/reports/bundleReport.vue";
import sewingInputReport from "@/views/module/production/reports/sewingInputReport.vue";
import sewingOutputReport from "@/views/module/production/reports/sewingOutputReport.vue";
import qcInlineReport from "@/views/module/production/reports/qcInlineReport.vue";
import qcFinalReport from "@/views/module/production/reports/qcFinalReport.vue";
import finishingInputReport from "@/views/module/production/reports/finishingInputReport.vue";
import finishingOutputReport from "@/views/module/production/reports/finishingOutputReport.vue";
import buyerOrderCreate from "@/views/module/production/buyerOrder/buyerOrderCreate.vue";

import buyerOrderList from "@/views/module/production/buyerOrder/buyerOrderList.vue";
import buyerOrderView from "@/views/module/production/buyerOrder/viweByerOrder.vue";
import productionOrderCreate from "@/views/module/production/productionOrder/productionOrderCreate.vue";
import productionOrderList from "@/views/module/production/productionOrder/productionOrderList.vue";
import productionOrderView from "@/views/module/production/productionOrder/viewProductionOrder.vue";
import dyeingSetup from "@/views/module/production/masterSetup/dyeingSetup.vue";
import dyeingOrderCreate from "@/views/module/production/dyeingOrder/dyeingOrdercreate.vue";
import dyeingOrderRecord from "@/views/module/production/dyeingOrder/dyeingOrderRecord.vue";
import dyeingOrderView from "@/views/module/production/dyeingOrder/dyeingOrderView.vue";

import proformaInvoiceCreate from "@/views/module/production/proformaInvoice/proformaInvoiceCreate.vue";
import proformaInvoiceRecord from "@/views/module/production/proformaInvoice/proformaInvoiceReccord.vue";
import proformaInvoiceView from "@/views/module/production/proformaInvoice/proformaInvoiceView.vue";

import masterSalesContactCreate from "@/views/module/production/masterSalesContract/masterSalesContactCreate.vue";
import masterSalesContactRecord from "@/views/module/production/masterSalesContract/masterSalesContactRecord.vue";
import masterSalesContactView from "@/views/module/production/masterSalesContract/masterSalesContactView.vue";
import salesContactCreate from "@/views/module/production/salesContact/salesContactCreate.vue";
import salesContactRecord from "@/views/module/production/salesContact/salesContactRecord.vue";
import salesContactView from "@/views/module/production/salesContact/salesContactView.vue";
import purchaseOrderCreate from "@/views/module/production/purchaseOrder/purchaseOrderCreate.vue";
import purchaseOrderRecord from "@/views/module/production/purchaseOrder/purchaseOrderRecord.vue";
import purchaseOrderView from "@/views/module/production/purchaseOrder/purchaseOrderView.vue";

import invoiceBillCreate from "@/views/module/production/invoiceBill/invoiceBillCreate.vue";
import invoiceBillRecord from "@/views/module/production/invoiceBill/invoiceBillRecord.vue";
import invoiceBillView from "@/views/module/production/invoiceBill/invoiceBillView.vue";
import textileOrderReport from "@/views/module/production/reports/textileOrderreport.vue";










export default [
{
    path: "/bhp",
    name: "bhp",
    component: LayoutAdmin,
    meta: {
        UserLoggedIn: true,
        breadcrumb: "Buying House Production",
    },
    children: [
        {
            path: "styles",
            name: "styles",
            meta: {
                breadcrumb: ["Buying House Production", "Style"],
            },
            component: style,
        },
        {
            path: "pos",
            name: "pos",
            meta: {
                breadcrumb: ["Buying House Production", "POS"],
            },
            component: pos,
        },
        {
            path: "colors",
            name: "colors",
            meta: {
                breadcrumb: ["Buying House Production", "Colors"],
            },
            component: color,
        },
        {
            path: "sizes",
            name: "sizes",
            meta: {
                breadcrumb: ["Buying House Production", "Sizes"],
            },
            component: size,
        },
        {
            path: "dyeing-setup",
            name: "dyeing-setup",
            meta: {
                breadcrumb: ["Buying House Production", "Dyeing"],
            },
            component: dyeingSetup,
        },
        {
           path: "bom-create/:id?",
            name: "bom-create",
            meta: {
                breadcrumb: ["Buying House Production", "Bom"],
            },
            component: bom,
        },
        {
            path: "bom-records",
            name: "bom-records",
            meta: {
                breadcrumb: ["Buying House Production", "Bom Records"],
            },
            component: bomRecord,
        },

        {
            path: "cutting-create",
            name: "cutting-create",
            meta: {
                breadcrumb: ["Buying House Production", "Cutting Entry"],
            },
            component: cuttingCreate,
        },
        {
            path: "cutting-create/:id",
            name: "cutting-edit",
            meta: {
                breadcrumb: ["Buying House Production", "Update Cutting Entry"],
            },
            component: cuttingCreate,
        },
        {
            path: "cutting-records",
            name: "cutting-records",
            meta: {
                breadcrumb: ["Buying House Production", "Cutting Records"],
            },
            component: cuttingRecords,
        },

        {
            path: "view-cutting/:id",
            name: "view-cutting",
            meta: {
                breadcrumb: ["Buying House Production", "View Cutting"],
            },
            component: viewCutting,
        },
        {
            path: "bundle-create",
            name: "bundle-create",
            meta: {
                breadcrumb: ["Buying House Production", "Bundle Entry"],
            },
            component: bundleCreate,
        },
        {
            path: "bundle-create/:id",
            name: "bundle-edit",
            meta: {
                breadcrumb: ["Buying House Production", "Update Bundle Entry"],
            },
            component: bundleCreate,
        },
        {
            path: "bundles",
            name: "bundle-records",
            meta: {
                breadcrumb: ["Buying House Production", "Bundle Records"],
            },
            component: bundleRecords,
        },
        {
            path: "sewing/lines",
            name: "sewing-lines",
            meta: {
                breadcrumb: ["Buying House Production", "Sewing Line"],
            },
            component: sewingLine,
        },
        {
            path: "sewing/input/:id?",
            name: "sewing-input",
            meta: {
                breadcrumb: ["Buying House Production", "Sewing Input"],
            },
            component: sewingInput,
        },

        {
            path: "sewing/output/:id?",
            name: "sewing-output",
            meta: {
                breadcrumb: ["Buying House Production", "Sewing Output"],
            },
            component: sewingOutput,
        },
        {
            path: "sewing/input-record",
            name: "sewing-input-record",
            meta: {
                breadcrumb: ["Buying House Production", "Sewing Input Records"],
            },
            component: sewingInputRecord,
        },
        {
            path: "sewing/output-record",
            name: "sewing-output-record",
            meta: {
                breadcrumb: ["Buying House Production", "Sewing Output Records"],
            },
            component: sewingOutputRecord,
        },
        {
            path: "sewing/input-view/:id",
            name: "sewing-input-view",
            meta: {
                breadcrumb: ["Buying House Production", "Sewing Input View"],
            },
            component: sewingInputView,
        },
        {
            path: "sewing/output-view/:id",
            name: "sewing-output-view",
            meta: {
                breadcrumb: ["Buying House Production", "Sewing Output View"],
            },
            component: sewingOutputView,
        },
        {
            path: "qc/entry/:id?",
            name: "qc-entry",
            meta: {
                breadcrumb: ["Buying House Production", "QC Entry"],
            },
            component: qcEntry,
        },
        {
            path: "qc/records",
            name: "qc-records",
            meta: {
                breadcrumb: ["Buying House Production", "QC Record"],
            },
            component: qcRecords,
        },
        {
            path: "qc/view/:id?",
            name: "qc-view",
            meta: {
                breadcrumb: ["Buying House Production", "QC View"],
            },
            component: qcView,
        },
        {
            path: "finishing/entry/:id?",
            name: "finishing-entry",
            meta: {
                breadcrumb: ["Buying House Production", "Finishing Entry"],
            },
            component: finishingEntry,
        },
        {
            path: "finishing/records",
            name: "finishing-records",
            meta: {
                breadcrumb: ["Buying House Production", "Finishing Records"],
            },
            component: finishingRecords,
        },
        {
            path: "view-finishing/:id",
            name: "view-finishing",
            meta: {
                breadcrumb: ["Buying House Production", "Finishing View"],
            },
            component: finishingView,
        },
        {
            path: "reports/styles",
            name: "style-report",
            meta: {
                breadcrumb: ["Buying House Production", "Style Report"],
            },
            component: styleReport,
        },
        {
            path: "reports/pos",
            name: "po-report",
            meta: {
                breadcrumb: ["Buying House Production", "PO Report"],
            },
            component: poReport,
        },
        {
            path: "reports/cutting",
            name: "cutting-report",
            meta: {
                breadcrumb: ["Buying House Production", "Cutting Report"],
            },
            component: cuttingReport,
        },
        {
            path: "reports/bundles",
            name: "bundle-report",
            meta: {
              breadcrumb: ["Buying House Production", "Bundle Report"],
            },
            component: bundleReport,
          },
          {
            path: "reports/sewing-input",
            name: "sewing-input-report",
            meta: {
                breadcrumb: ["Buying House Production", "Sewing Input Report"],
            },
            component: sewingInputReport,
        },
        {
            path: "reports/sewing-output",
            name: "sewing-output-report",
            meta: {
                breadcrumb: ["Buying House Production", "Sewing Output Report"],
            },
            component: sewingOutputReport,
        },
        {
            path: "reports/qc-inline",
            name: "qc-inline-report",
            meta: {
                breadcrumb: ["Buying House Production", "Inline QC Report"],
            },
            component: qcInlineReport,
        },
        {
            path: "reports/qc-final",
            name: "qc-final-report",
            meta: {
                breadcrumb: ["Buying House Production", "Final QC Report"],
            },
            component: qcFinalReport,
        },
        {
            path: "reports/finishing-input",
            name: "finishing-input-report",
            meta: {
                breadcrumb: ["Buying House Production", "Finishing Input Report"],
            },
            component: finishingInputReport,
        },
        {
            path: "reports/finishing-output",
            name: "finishing-output-report",
            meta: {
                breadcrumb: ["Buying House Production", "Finishing Output Report"],
            },
            component: finishingOutputReport,
        },
        {
            path: "reports/textile/order",
            name: "textile-order-report",
            meta: {
                breadcrumb: ["Buying House Production", "Textile Order Report"],
            },
            component: textileOrderReport,
        },
        
        {
            path: "buyer-order-create/:id?",
            name: "buyer-order-create",
            meta: {
                breadcrumb: ["Buying House Production", "Buyer Order Create"],
            },
            component: buyerOrderCreate,
        },
        {
            path: "buyer-order-records",
            name: "buyer-order-records",
            meta: {
                breadcrumb: ["Buying House Production", "Buyer Order List"],
            },
            component: buyerOrderList,
        },
        {
            path: "buyer-order-view/:id",
            name: "buyer-order-view",
            meta: {
                breadcrumb: ["Buying House Production", "Buyer Order View"],
            },
            component: buyerOrderView,
        },
        {
            path: "production-order-create/:id?",
            name: "production-order-create",
            meta: {
                breadcrumb: ["Buying House Production", "Production Order Create"],
            },
            component: productionOrderCreate,
        },
        {
            path: "production-order-records",
            name: "production-order-records",
            meta: {
                breadcrumb: ["Buying House Production", "Production Order Records"],
            },
            component: productionOrderList,
        },
        {
            path: "production-order-view/:id",
            name: "production-order-view",
            meta: {
                breadcrumb: ["Buying House Production", "Production Order View"],
            },
            component: productionOrderView,
        },
        {
            path: "textile-order-create/:id?",
            name: "textile-order-create",
            meta: {
                breadcrumb: ["Buying House Production", "Textile Order Create"],
            },
            component: dyeingOrderCreate,
        },
        {
            path: "textile-order-record",
            name: "textile-order-record",
            meta: {
                breadcrumb: ["Buying House Production", "Textile Order Records"],
            },
            component: dyeingOrderRecord,
        },
        {
            path: "textile-order-view/:id",
            name: "textile-order-view",
            meta: {
                breadcrumb: ["Buying House Production", "Textile Order View"],
            },
            component: dyeingOrderView,
        },
        {
            path: "proforma-invoice-create/:id?",
            name: "proforma-invoice-create",
            meta: {
                breadcrumb: ["Buying House Production", "Proforma Invoice Create"],
            },
            component: proformaInvoiceCreate,
        },
        {
            path: "proforma-invoice-record",
            name: "proforma-invoice-record",
            meta: {
                breadcrumb: ["Buying House Production", "Proforma Invoice Records"],
            },
            component: proformaInvoiceRecord,
        },
        {
            path: "proforma-invoice-view/:id",
            name: "proforma-invoice-view",
            meta: {
                breadcrumb: ["Buying House Production", "Proforma Invoice View"],
            },
            component: proformaInvoiceView,
        },
        {
            path: "master-sales-contact-create/:id?",
            name: "master-sales-contact-create",
            meta: {
                breadcrumb: ["Buying House Production", "Master Sales Contact Create"],
            },
            component: masterSalesContactCreate,
        },
        {
            path: "master-sales-contact-record",
            name: "master-sales-contact-record",
            meta: {
                breadcrumb: ["Buying House Production", "Master Sales Contact Records"],
            },
            component: masterSalesContactRecord,
        },
        {
            path: "master-sales-contact-view/:id",
            name: "master-sales-contact-view",
            meta: {
                breadcrumb: ["Buying House Production", "Master Sales Contact View"],
            },
            component: masterSalesContactView,
        },
        {
            path: "sales-contact-create/:id?",
            name: "sales-contact-create",
            meta: {
                breadcrumb: ["Buying House Production", "Sales Contact Create"],
            },
            component: salesContactCreate,
        },
        {
            path: "sales-contact-record",
            name: "sales-contact-record",
            meta: {
                breadcrumb: ["Buying House Production", "Sales Contact Records"],
            },
            component: salesContactRecord,
        },
        {
            path: "sales-contact-view/:id",
            name: "sales-contact-view",
            meta: {
                breadcrumb: ["Buying House Production", "Sales Contact View"],
            },
            component: salesContactView,
        },
        {
            path: "purchase-order-create/:id?",
            name: "purchase-order-create",
            meta: {
                breadcrumb: ["Buying House Production", "Purchase Order Create"],
            },
            component: purchaseOrderCreate,
        },
        {
            path: "purchase-order-record",
            name: "purchase-order-record",
            meta: {
                breadcrumb: ["Buying House Production", "Purchase Order Records"],
            },
            component: purchaseOrderRecord,
        },
        {
            path: "purchase-order-view/:id",
            name: "purchase-order-view",
            meta: {
                breadcrumb: ["Buying House Production", "Purchase Order View"],
            },
            component: purchaseOrderView,
        },

        {
            path: "invoice-bill-create/:id?",
            name: "invoice-bill-create",
            meta: {
                breadcrumb: ["Buying House Production", "Invoice Bill Create"],
            },
            component: invoiceBillCreate,
        },
        {
            path: "invoice-bill-record",
            name: "invoice-bill-record",
            meta: {
                breadcrumb: ["Buying House Production", "Invoice Bill Records"],
            },
            component: invoiceBillRecord,
        },
        {
            path: "invoice-bill-view/:id",
            name: "invoice-bill-view",
            meta: {
                breadcrumb: ["Buying House Production", "Invoice Bill View"],
            },
            component: invoiceBillView,
        },
        
    ],
  },
];
